import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
// @material-ui/core components
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  Fab,
  FormControlLabel,
  IconButton,
  makeStyles,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useTheme,
} from "@material-ui/core";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import {
  baseUrl,
  CheckQuantity,
  CreateChallanAPI,
  CreateCreditNoteAPI,
  CreateDebitNoteAPI,
  GetAllAccountsAPI,
  GetAllAccountsWithLightweightAPI,
  GetAllFittingMastersAPI,
  GetAllOrdersAPI,
  GetAllReadyMastersAPI,
  GetAllReadyMastersCodesAPI,
  UpdateOrderAPI,
} from "../../config/api";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector } from "react-redux";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { ChallanOrdersDialog } from "./ChallanOrdersDialog.js";
import { ColorsDialog } from "./ColorsDialog.js";
import { toast } from "react-toastify";
import { Filter9Plus } from "@material-ui/icons";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateUtils from "@date-io/moment";
import moment from "moment";
import debounce from "lodash/debounce";
import { useLocation } from "react-router-dom";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

const useStyles = makeStyles((theme) => ({
  fab: {
    marginTop: 26,
  },
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
}));

let columns = [
  { id: "codeR", label: "Code R" },
  { id: "codeL", label: "Code L" },
  { id: "nameR", label: "Name R" },
  { id: "nameL", label: "Name L" },
  { id: "quantity", label: "Quantity" },
  { id: "rateR", label: "Rate R" },
  { id: "rateL", label: "Rate L" },
  { id: "rate", label: "Rate" },
  {
    id: "discountAmount",
    label: "Discount Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "discountPercent", label: "Discount Percent" },
  { id: "fitting", label: "Fitting" },
  {
    id: "fittingAmount",
    label: "Fitting Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "tint", label: "Tint" },
  {
    id: "amount",
    label: "Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "orderRef", label: "Order Ref" },
  { id: "action", label: "Action" },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function ChallanAddDialog(props) {
  const location = useLocation();

  const classes = useStyles();
  const theme = useTheme();
  const { open, close, readyMasterRange, showPrintModal } = props;
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);

  const [users, setUsers] = useState([]);
  const [readyMasters, setReadyMasters] = useState([]);
  const [party, setParty] = useState(null);
  const [codeL, setCodeL] = useState(null);
  const [codeR, setCodeR] = useState(null);
  const [isPrescriptionOrderMode, setIsPrescriptionOrderMode] = useState(false);
  const [nameL, setNameL] = useState("");
  const [nameR, setNameR] = useState("");
  const [brandR, setBrandR] = useState("");
  const [brandL, setBrandL] = useState("");
  const [lProductCode, setLProductCode] = useState("");
  const [rProductCode, setRProductCode] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rateR, setRateR] = useState("");
  const [rateL, setRateL] = useState("");
  const [rate, setRate] = useState("");
  const [discountPercent, setDiscountPercent] = useState(0);
  const [discountAmount, setDiscountAmount] = useState("");
  const [fitting, setFitting] = useState("");
  const [fittingAmount, setFittingAmount] = useState("");
  const [tint, setTint] = useState("");
  const [amount, setAmount] = useState("");
  const [orderRef, setOrderRef] = useState("");
  const [items, setItems] = useState([]);
  const [coating, setCoating] = useState("");
  const [orders, setOrders] = useState([]);
  const [codes, setCodes] = useState([]);
  const [codesL, setCodesL] = useState([]);
  const [codesR, setCodesR] = useState([]);
  const [lSph, setLsph] = useState("");
  const [rSph, setRsph] = useState("");
  const [lCyl, setLcyl] = useState("");
  const [rCyl, setRcyl] = useState("");
  const [rAxis, setRaxis] = useState("");
  const [lAxis, setLaxis] = useState("");
  const [lAdd, setLadd] = useState("");
  const [rAdd, setRadd] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [taxPercent, setTaxPercent] = useState("5");
  const [packagingCost, setPackagingCost] = useState("");
  const [packagingTaxPercent, setPackagingTaxPercent] = useState("5");
  const [fittingMasters, setFittingMasters] = useState([]);
  const [fittingMastersCodes, setFittingMastersCodes] = useState([]);
  const [openOrdersDialog, setOpenOrdersDialog] = useState(false);
  const [openColorsDialog, setOpenColorsDialog] = useState(false);
  const [challanDate, setChallanDate] = useState(null);
  const [selectR, setSelectR] = useState({});
  const [selectL, setSelectL] = useState({});
  const [reverseEntry, setReverseEntry] = useState(false);

  // Loading states
  const [loadingFittingMasters, setLoadingFittingMasters] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [loadingCodesR, setLoadingCodesR] = useState(false);
  const [loadingCodesL, setLoadingCodesL] = useState(false);
  const [isSavingChallan, setIsSavingChallan] = useState(false);

  // Refs for request cancellation
  const abortControllerRef = useRef(null);
  const ordersAbortControllerRef = useRef(null);
  const codesRAbortControllerRef = useRef(null);
  const codesLAbortControllerRef = useRef(null);

  // Cache for orders by party ID
  const ordersCacheRef = useRef(new Map());

  // Refs to access current state values in closures (must be before debounced functions)
  const codeRRef = useRef(codeR);
  const codeLRef = useRef(codeL);

  // Refs to store debounced functions for cleanup
  const debouncedEffectRef = useRef(null);
  const debouncedEffectLRef = useRef(null);

  // Cache for fitting masters (entity-specific, rarely changes)
  const fittingMastersCacheKey = `fittingMasters_${userInfo?.entity}`;

  // Client-side cache for codes API results
  const codesCacheRef = useRef(new Map());
  const CACHE_TTL = 15 * 60 * 1000; // 15 minutes

  // Helper function to get cache key
  const getCodesCacheKey = useCallback((entity, productCode, side) => {
    return `${entity}_${productCode}_${side}`;
  }, []);

  // Helper function to check cache with smart prefix matching
  const getCachedCodes = useCallback((entity, productCode, side) => {
    // Try exact match first
    const exactKey = getCodesCacheKey(entity, productCode, side);
    const exactCached = codesCacheRef.current.get(exactKey);
    if (exactCached && Date.now() - exactCached.timestamp < CACHE_TTL) {
      return exactCached.data;
    }

    // Try prefix matches (check if longer search is subset of cached shorter search)
    // Check prefixes from longest to shortest
    for (let i = productCode.length - 1; i >= 3; i--) {
      const prefix = productCode.substring(0, i);
      const prefixKey = getCodesCacheKey(entity, prefix, side);
      const prefixCached = codesCacheRef.current.get(prefixKey);
      if (prefixCached && Date.now() - prefixCached.timestamp < CACHE_TTL) {
        // Filter cached results to match current search
        const filtered = prefixCached.data.filter(code =>
          code.productCode && code.productCode.toLowerCase().startsWith(productCode.toLowerCase())
        );
        if (filtered.length > 0) {
          return filtered;
        }
      }
    }

    return null;
  }, [getCodesCacheKey]);

  // Helper function to set cache
  const setCachedCodes = useCallback((entity, productCode, side, data) => {
    const key = getCodesCacheKey(entity, productCode, side);
    codesCacheRef.current.set(key, {
      data,
      timestamp: Date.now()
    });
  }, [getCodesCacheKey]);

  console.log(selectR, selectL, "<<<<<<<RL");

  // Update refs when state changes
  useEffect(() => {
    codeRRef.current = codeR;
  }, [codeR]);

  useEffect(() => {
    codeLRef.current = codeL;
  }, [codeL]);

  // Cleanup function to undo operations when codeR is removed
  const cleanupCodeR = useCallback(() => {
    // Clear R-specific fields
    setNameR("");
    setRateR("");
    setRProductCode("");
    setRsph("");
    setRcyl("");
    setRaxis("");
    setRadd("");
    setBrandR("");

    // Clear shared fields only if codeL is also empty
    if (!codeL) {
      setQuantity("");
      setFittingAmount("");
      setFitting("");
      setOrderRef("");
      setRate("");
      setHsnCode("");
      setTaxPercent("");
      setPackagingTaxPercent("");
      setDiscountPercent("");
      setCoating("");
    } else {
      // If codeL exists, only clear rate (it will be recalculated from rateL)
      // Recalculate rate based on rateL only
      if (rateL) {
        setRate(rateL.toString());
      } else {
        setRate("");
      }
    }
  }, [codeL, rateL]);

  // Cleanup function to undo operations when codeL is removed
  const cleanupCodeL = useCallback(() => {
    // Clear L-specific fields
    setNameL("");
    setRateL("");
    setLProductCode("");
    setLsph("");
    setLcyl("");
    setLaxis("");
    setLadd("");
    setBrandL("");

    // Clear shared fields only if codeR is also empty
    if (!codeR) {
      setQuantity("");
      setFittingAmount("");
      setFitting("");
      setOrderRef("");
      setRate("");
      setHsnCode("");
      setTaxPercent("");
      setPackagingTaxPercent("");
      setDiscountPercent("");
      setCoating("");
    } else {
      // If codeR exists, only clear rate (it will be recalculated from rateR)
      // Recalculate rate based on rateR only
      if (rateR) {
        setRate(rateR.toString());
      } else {
        setRate("");
      }
    }
  }, [codeR, rateR]);

  // Callback function that will be passed to child
  const setR = (data) => {
    setSelectR(data); // Update parent state
    if (data && data.code) {
      setCodeR(data.code); // Set the codeR value

      // If it's an order with orderDetail, populate fields directly
      if (data.orderDetail) {
        setQuantity(data.quantity);
        setOrderRef(data.code);

        // Set power fields for R
        if (data.orderDetail.rSph !== undefined) setRsph(data.orderDetail.rSph);
        if (data.orderDetail.rCyl !== undefined) setRcyl(data.orderDetail.rCyl);
        if (data.orderDetail.rAxis !== undefined) setRaxis(data.orderDetail.rAxis);
        if (data.orderDetail.rAddition !== undefined) setRadd(data.orderDetail.rAddition);

        // Set initial rate from order price
        if (data.price !== undefined) {
          setRateR(data.price);
        }

        let productCode = "";
        if (data.orderType === "Fitting") {
          if (data.orderDetail.fitting) {
            setFitting(data.orderDetail.fitting);
            let fitting = _.find(fittingMasters, {
              fittingType: data.orderDetail.fitting,
            });
            if (fitting) {
              setFittingAmount(fitting.amount);
            }
          }
          // Override with Fitting-specific rate
          if (data.orderDetail.rRate !== undefined) {
            setRateR(data.orderDetail.rRate);
          }
          productCode =
            data.orderDetail.rSph +
            "/" +
            data.orderDetail.rCyl +
            "/" +
            data.orderDetail.rAxis +
            "/" +
            data.orderDetail.rAddition;
          setNameR(
            [
              data.orderDetail.product?.index ?? data.orderDetail.fitter,
              data.orderDetail.productName ?? data.orderDetail.productNameR,
              data.orderDetail.product?.coating ?? data.orderDetail.fitting,
              productCode,
            ]
              .filter(Boolean)
              .join("-")
          );
        } else {
          // For non-Fitting orders
          productCode =
            data.orderDetail.rSph +
            "/" +
            data.orderDetail.rCyl +
            "/" +
            data.orderDetail.rAxis +
            "/" +
            data.orderDetail.rAddition;
          if (data.orderDetail.product) {
            setNameR(
              [
                data.orderDetail.product.index,
                data.orderDetail.product.productName,
                data.orderDetail.product.coating,
                productCode,
              ]
                .filter(Boolean)
                .join("-")
            );
            // Override with product price if available
            if (data.orderDetail.product.price !== undefined) {
              setRateR(data.orderDetail.product.price);
            } else if (data.rate !== undefined) {
              setRateR(data.rate);
            }
            setHsnCode(data.orderDetail.product.hsnCode);
            setTaxPercent(data.orderDetail.product.taxPercent);
            setPackagingTaxPercent(data.orderDetail.product.taxPercent);
          } else {
            setNameR(
              (data.orderDetail.productName || "") +
              (productCode ? "-" + productCode : "")
            );
            // Use rate if price not set
            if (data.rate !== undefined && data.price === undefined) {
              setRateR(data.rate);
            }
          }
        }
        setRProductCode(productCode);
        if (data.orderDetail.coat) {
          setCoating(data.orderDetail.coat);
        }
        // For orders, set discount to 0 (orders have fixed prices, discounts don't apply)
        setDiscountPercent(0);
      } else {
        // If not an order, use the existing selection logic
        afterSelectR(data.code);
      }
    }
  };
  const setL = (data) => {
    setSelectL(data); // Update parent state
    if (data && data.code) {
      setCodeL(data.code); // Set the codeL value

      // If it's an order with orderDetail, populate fields directly
      if (data.orderDetail) {
        setQuantity(data.quantity);
        setOrderRef(data.code);

        // Set power fields for L
        if (data.orderDetail.lSph !== undefined) setLsph(data.orderDetail.lSph);
        if (data.orderDetail.lCyl !== undefined) setLcyl(data.orderDetail.lCyl);
        if (data.orderDetail.lAxis !== undefined) setLaxis(data.orderDetail.lAxis);
        if (data.orderDetail.lAddition !== undefined) setLadd(data.orderDetail.lAddition);

        // Set initial rate from order price
        if (data.price !== undefined) {
          setRateL(data.price);
        }

        let productCode = "";
        if (data.orderType === "Fitting") {
          if (data.orderDetail.fitting) {
            setFitting(data.orderDetail.fitting);
            let fitting = _.find(fittingMasters, {
              fittingType: data.orderDetail.fitting,
            });
            if (fitting) {
              setFittingAmount(fitting.amount);
            }
          }
          // Override with Fitting-specific rate
          if (data.orderDetail.lRate !== undefined) {
            setRateL(data.orderDetail.lRate);
          }
          productCode =
            data.orderDetail.lSph +
            "/" +
            data.orderDetail.lCyl +
            "/" +
            data.orderDetail.lAxis +
            "/" +
            data.orderDetail.lAddition;
          setNameL(
            [
              data.orderDetail.product?.index ?? data.orderDetail.fitter,
              data.orderDetail.productName ?? data.orderDetail.productNameR,
              data.orderDetail.product?.coating ?? data.orderDetail.fitting,
              productCode,
            ]
              .filter(Boolean)
              .join("-")
          );
        } else {
          // For non-Fitting orders
          productCode =
            data.orderDetail.lSph +
            "/" +
            data.orderDetail.lCyl +
            "/" +
            data.orderDetail.lAxis +
            "/" +
            data.orderDetail.lAddition;
          if (data.orderDetail.product) {
            setNameL(
              [
                data.orderDetail.product.index,
                data.orderDetail.product.productName,
                data.orderDetail.product.coating,
                productCode,
              ]
                .filter(Boolean)
                .join("-")
            );
            // Override with product price if available
            if (data.orderDetail.product.price !== undefined) {
              setRateL(data.orderDetail.product.price);
            } else if (data.rate !== undefined) {
              setRateL(data.rate);
            }
            setHsnCode(data.orderDetail.product.hsnCode);
            setTaxPercent(data.orderDetail.product.taxPercent);
            setPackagingTaxPercent(data.orderDetail.product.taxPercent);
          } else {
            setNameL(
              (data.orderDetail.productName || "") +
              (productCode ? "-" + productCode : "")
            );
            // Use rate if price not set
            if (data.rate !== undefined && data.price === undefined) {
              setRateL(data.rate);
            }
          }
        }
        setLProductCode(productCode);
        if (data.orderDetail.coat) {
          setCoating(data.orderDetail.coat);
        }
      } else {
        // If not an order, use the existing selection logic
        afterSelectL(data.code);
      }
    }
  };

  const [filteredOptions, setFilteredOptions] = useState([]);

  // Memoized calculations
  const sumOfQuantities = useMemo(() => {
    return items.reduce((accumulator, currentValue) => {
      return Number(accumulator + Number(currentValue.quantity));
    }, 0);
  }, [items]);

  const sumOfAmounts = useMemo(() => {
    return items.reduce((accumulator, currentValue) => {
      return Number(accumulator + Number(currentValue.amount));
    }, 0);
  }, [items]);

  useEffect(() => {
    _getFittingMasters();
    _getUsers();

    // Cleanup on unmount
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      if (ordersAbortControllerRef.current) {
        ordersAbortControllerRef.current.abort();
      }
      if (codesRAbortControllerRef.current) {
        codesRAbortControllerRef.current.abort();
      }
      if (codesLAbortControllerRef.current) {
        codesLAbortControllerRef.current.abort();
      }
      // Cleanup debounced functions using refs
      if (debouncedEffectRef.current) {
        debouncedEffectRef.current.cancel();
      }
      if (debouncedEffectLRef.current) {
        debouncedEffectLRef.current.cancel();
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    _getOrders();

    // Cleanup when party changes
    return () => {
      if (ordersAbortControllerRef.current) {
        ordersAbortControllerRef.current.abort();
      }
    };
  }, [party]);

  // Memoized codes from orders
  const orderCodes = useMemo(() => {
    return orders.map((i) => i.code).filter(Boolean);
  }, [orders]);

  const debouncedEffectL = useMemo(
    () => {
      const debounced = _.debounce((codeL) => {
        console.log("debounce EL");
        let obj;
        let codes = [...orderCodes];
        let codesL = [...orderCodes];
        if (codeL) {
          obj = orders.find((o) => o.code === codeL);
          if (!obj) {
            if (codeL?.length < 5) {
              return;
            }

            // Check cache first
            const cachedData = getCachedCodes(userInfo.entity, codeL, "L");
            if (cachedData) {
              setReadyMasters(cachedData);
              const readyMasterCodes = cachedData.map((i) => i.productCode);
              const readyMasterCodesL = cachedData
                .filter((i) => i.side === "B" || i.side === "L")
                .map((i) => i.productCode);

              codes = [...orderCodes, ...readyMasterCodes];
              codesL = [...orderCodes, ...readyMasterCodesL];

              // Sort codesL array - move codes starting with 'o' to the end, then sort each group alphabetically
              codesL.sort((a, b) => {
                const aStartsWithO = a.toLowerCase().startsWith("o");
                const bStartsWithO = b.toLowerCase().startsWith("o");

                if (aStartsWithO && !bStartsWithO) {
                  return 1;
                } else if (!aStartsWithO && bStartsWithO) {
                  return -1;
                }
                return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
              });

              // Also sort the main codes array
              codes.sort((a, b) => {
                const aStartsWithO = a.toLowerCase().startsWith("o");
                const bStartsWithO = b.toLowerCase().startsWith("o");

                if (aStartsWithO && !bStartsWithO) {
                  return 1;
                } else if (!aStartsWithO && bStartsWithO) {
                  return -1;
                }
                return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
              });

              setCodesL(codesL);
              setCodes(codes);
              return;
            }

            // Cancel previous request
            if (codesLAbortControllerRef.current) {
              codesLAbortControllerRef.current.abort();
            }
            codesLAbortControllerRef.current = new AbortController();

            setLoadingCodesL(true);
            axios
              .get(GetAllReadyMastersCodesAPI(userInfo.entity, codeL, "L"), {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                signal: codesLAbortControllerRef.current.signal,
              })
              .then((res) => {
                const readyMastersData = res.data.readyMasters || [];
                // Limit results to 200 on frontend as well
                const limitedReadyMasters = readyMastersData.slice(0, 200);

                // Cache the results
                setCachedCodes(userInfo.entity, codeL, "L", limitedReadyMasters);

                setReadyMasters(limitedReadyMasters);
                const readyMasterCodes = limitedReadyMasters.map((i) => i.productCode);
                const readyMasterCodesL = limitedReadyMasters
                  .filter((i) => i.side === "B" || i.side === "L")
                  .map((i) => i.productCode);

                codes = [...orderCodes, ...readyMasterCodes];
                codesL = [...orderCodes, ...readyMasterCodesL];

                // Sort codesL array - move codes starting with 'o' to the end, then sort each group alphabetically
                codesL.sort((a, b) => {
                  const aStartsWithO = a.toLowerCase().startsWith("o");
                  const bStartsWithO = b.toLowerCase().startsWith("o");

                  // First, separate codes starting with 'o' from others
                  if (aStartsWithO && !bStartsWithO) {
                    return 1;
                  } else if (!aStartsWithO && bStartsWithO) {
                    return -1;
                  }
                  // Within the same group, sort alphabetically/numerically
                  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });
                setCodesL(codesL);

                // Also sort the main codes array
                codes.sort((a, b) => {
                  const aStartsWithO = a.toLowerCase().startsWith("o");
                  const bStartsWithO = b.toLowerCase().startsWith("o");

                  if (aStartsWithO && !bStartsWithO) {
                    return 1;
                  } else if (!aStartsWithO && bStartsWithO) {
                    return -1;
                  }
                  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });
                setCodes(codes);
              })
              .catch((e) => {
                if (e.name !== 'AbortError' && e.code !== 'ECONNABORTED') {
                  //console.log(e, "<<err");
                }
              })
              .finally(() => {
                setLoadingCodesL(false);
              });
          }
          // Sort codes before setting (when code length < 5, codes = orderCodes)
          codes.sort((a, b) => {
            const aStartsWithO = a.toLowerCase().startsWith("o");
            const bStartsWithO = b.toLowerCase().startsWith("o");

            if (aStartsWithO && !bStartsWithO) {
              return 1;
            } else if (!aStartsWithO && bStartsWithO) {
              return -1;
            }
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
          });
          setCodes(codes);
          if (obj) {
            if (obj.productName) {
              setNameL(obj.productName);
              setRateL(obj.rate);
              setLProductCode(obj.productCode);
            } else {
              if (obj.orderDetail) {
                console.log("232", obj);
                setQuantity(obj.quantity);
                setRateL(obj.price);
                setHsnCode(obj.orderDetail.product.hsnCode);
                let productCode = "";
                if (obj.orderType === "Fitting") {
                  if (obj.orderDetail.fitting) {
                    setFitting(obj.orderDetail.fitting);
                    let fitting = _.find(fittingMasters, {
                      fittingType: obj.orderDetail.fitting,
                    });
                    setFittingAmount(fitting.amount);
                  }
                  setRateL(obj.orderDetail.lRate);
                  productCode =
                    obj.orderDetail.lSph +
                    "/" +
                    obj.orderDetail.lCyl +
                    "/" +
                    obj.orderDetail.lAxis +
                    "/" +
                    obj.orderDetail.lAddition;
                  setNameL(obj.orderDetail.productName + "-" + productCode);
                  setNameL(
                    [
                      obj.orderDetail.product.index ?? obj.orderDetail.fitter,
                      obj.orderDetail.productName ?? obj.orderDetail.productNameR,
                      obj.orderDetail.product.coating ?? obj.orderDetail.fitting,
                      productCode,
                    ]
                      .filter(Boolean) // Removes undefined, null, or empty values
                      .join("-") // Joins the valid values with "-"
                  );
                } else {
                  setRateL(obj.price);
                  productCode =
                    obj.orderDetail.lSph +
                    "/" +
                    obj.orderDetail.lCyl +
                    "/" +
                    obj.orderDetail.lAxis +
                    "/" +
                    obj.orderDetail.lAddition;
                  if (obj.orderDetail.product) {
                    setNameL(
                      obj.orderDetail.product.productName + "-" + productCode
                    );
                  }
                }
                setOrderRef(obj.code);
                setLProductCode(productCode);
              }
            }
          }
        }
        if (!codeL) {
          // Check if codeR is also empty using ref
          if (!codeRRef.current) {
            setQuantity("");
            setFittingAmount("");
            setFitting("");
            setOrderRef("");
            setRate("");
            setHsnCode("");
            setDiscountPercent("");
            setTaxPercent("");
          }
          setNameL("");
          setRateL("");
          setLProductCode("");
        }
      }, 500);
      debouncedEffectLRef.current = debounced;
      return debounced;
    },
    [orders, orderCodes, fittingMasters, userInfo.entity, authToken, getCachedCodes, setCachedCodes]
  );

  const afterSelectR = useCallback((codeR) => {
    if (!codeR) return;

    console.log("[afterSelectR] Processing code:", codeR);

    let selectedItem = null;

    // 1. Check if it's an existing order
    if (orders?.length > 0) {
      selectedItem = orders.find((order) => order.code === codeR);
    }

    // 2. If not order → check current readyMasters
    if (!selectedItem && readyMasters?.length > 0) {
      selectedItem = _.find(readyMasters, { productCode: codeR });
    }

    // 3. If still not found → try prefix-based cache lookup
    if (!selectedItem && codeR?.length >= 5) {
      for (let len = codeR.length; len >= 5; len--) {
        const prefix = codeR.substring(0, len);
        const cached = getCachedCodes(userInfo.entity, prefix, "R");

        if (cached?.length > 0) {
          const match = cached.find((item) => item.productCode === codeR);
          if (match) {
            selectedItem = match;
            // Cache the whole batch for future quick lookups
            setReadyMasters(cached);
            break;
          }
        }
      }
    }

    if (!selectedItem) {
      console.warn("[afterSelectR] No item found for code:", codeR);
      return;
    }

    console.log("[afterSelectR] Selected item:", selectedItem);

    // ───────────────────────────────────────────────
    // CASE 1: It's an order / prescription item
    // ───────────────────────────────────────────────
    if (selectedItem.orderDetail) {
      const detail = selectedItem.orderDetail;
      const isFitting = selectedItem.orderType === "Fitting";

      setQuantity(selectedItem.quantity);

      let powerParts = [
        detail.rSph ?? '',
        detail.rCyl ?? '',
        detail.rAxis ?? '',
        detail.rAddition ?? ''
      ].filter(Boolean).join('/');

      let displayName = '';

      if (isFitting) {
        if (detail.fitting) {
          setFitting(detail.fitting);
          const fittingMaster = _.find(fittingMasters, { fittingType: detail.fitting });
          if (fittingMaster) setFittingAmount(fittingMaster.amount);
        }
        setRateR(detail.rRate);
        displayName = `${detail.productName || 'Fitting'} - ${powerParts}`;
      } else {
        setRateR(selectedItem.rate);
        if (detail.product) {
          displayName = `${detail.product.productName || ''} - ${powerParts}`;
        }
      }

      setNameR(displayName);
      setRProductCode(powerParts);
      setOrderRef(selectedItem.code);

      return; // Orders skip discount logic
    }

    // ───────────────────────────────────────────────
    // CASE 2: Ready master item
    // ───────────────────────────────────────────────
    if (!selectedItem.productName && !selectedItem.productCode) {
      console.warn("[afterSelectR] Invalid ready master item:", selectedItem);
      return;
    }

    // Basic fields
    const indexPrefix = selectedItem.index ? `${selectedItem.index}-` : '';
    setNameR(indexPrefix + (selectedItem.productName || selectedItem.productCode || ''));
    setBrandR(selectedItem.brand);
    setRateR(selectedItem?.rate);
    setRProductCode(selectedItem?.productCode);
    setHsnCode(selectedItem?.hsnCode);
    setTaxPercent(selectedItem?.taxPercent);
    setPackagingTaxPercent(selectedItem?.taxPercent);
    setRsph(selectedItem?.sph);
    setRcyl(selectedItem?.cyl);
    setRaxis(selectedItem?.axis);
    setRadd(selectedItem?.addition);

    // ───────────────────────────────────────────────
    // Discount logic — only for ready masters
    // Priority: 1. Range (productName + productCode match) → 2. Color
    // ───────────────────────────────────────────────
    const discounts = (party?.discounts || []).slice().reverse(); // newest first
    const inputName = (selectedItem.productName || '').trim().toLowerCase();
    const inputCode = (selectedItem.productCode || '').trim();
    const inputColor = (selectedItem.color || '').trim().toLowerCase();

    console.log("[Discount Check]", { name: inputName, code: inputCode, color: inputColor });

    let appliedDiscount = null;

    // 1. Try Range discount — must match BOTH name and code
    appliedDiscount = discounts.find((rule) => {
      if (rule.type !== "Range") return false;
      if (!rule.product) return false;

      const ruleName = (rule.product.productName || '').trim().toLowerCase();
      const nameMatch = ruleName === inputName;

      const codeMatch = rule.product.codeRanges?.some((code) =>
        String(code).trim() === inputCode
      ) ?? false;

      return nameMatch && codeMatch;
    });

    // 2. If no Range → try Color
    if (!appliedDiscount) {
      appliedDiscount = discounts.find((rule) => {
        const isColorRule = !rule.type || rule.type === "Color";
        if (!isColorRule) return false;
        if (!rule.product?.color || !inputColor) return false;

        return String(rule.product.color).trim().toLowerCase() === inputColor;
      });
    }

    if (appliedDiscount) {
      console.log("[Discount Applied]", {
        type: appliedDiscount.type || "Color",
        name: appliedDiscount.product?.productName,
        percent: appliedDiscount.discountPercent,
        discountedPrice: appliedDiscount.discountedPrice
      });

      // Apply
      // if (appliedDiscount.product?.productName) {
      //   setNameR(appliedDiscount.product.productName);
      // }

      setDiscountPercent(appliedDiscount.discountPercent || 0);

      // Uncomment when you're ready to use fixed price instead of percentage
      // if (appliedDiscount.discountedPrice != null) {
      //   setRateR(appliedDiscount.discountedPrice);
      //   // setDiscountPercent(0); // optional
      // }
    } else {
      console.log("[Discount] No matching rule found → discountPercent = 0");
      setDiscountPercent(0);
    }

  }, [
    orders,
    readyMasters,
    fittingMasters,
    party,
    userInfo.entity,
    getCachedCodes,
    // Note: discountPercent is used only in old averaging logic → can be removed from deps if you want
  ]);

  // const afterSelectL = (codeL) => {
  //   console.log("after EL", codeL)
  //   let obj = _.find(readyMasters, { productCode: codeL });
  //   if (obj) {
  //     if (obj?.productName) {
  //       setNameL(obj?.productName);
  //       setRateL(obj?.rate);
  //       setLProductCode(obj?.productCode);

  //       setHsnCode(obj?.hsnCode);
  //       setTaxPercent(obj?.taxPercent);

  //       let dissArray = party?.discounts;
  //       console.log("it is", obj, dissArray)

  //       if (dissArray && obj) {

  //         let selectedDis = dissArray
  //           .reverse()
  //           .find((item) => item.type === "Range");
  //         if (selectedDis) {

  //           let fR = selectedDis?.product?.codeRanges?.find((item) => (item === codeL))

  //           if (fR != undefined) {
  //             setNameL(selectedDis?.product?.productName)
  //             let newD = Number(discountPercent) + Number(selectedDis.discountPercent)
  //             let finD = newD / 2
  //             setDiscountPercent(finD);
  //           } else {

  //           }
  //         } else {
  //           let selectedDis2 = dissArray
  //             .reverse()
  //             .find((item) => item.product.color === obj.color);

  //           if (selectedDis2) {

  //             setNameL(selectedDis2?.product?.productName)
  //             if (discountPercent == 0) {
  //               setDiscountPercent(selectedDis2?.discountPercent)
  //             } else {

  //               let newD =
  //                 Number(discountPercent) +
  //                 Number(selectedDis2?.discountPercent);
  //               let finD = newD / 2;
  //               setDiscountPercent(finD);
  //             }
  //           } else {
  //           }
  //         }
  //       }
  //     } else {
  //       if (obj.orderDetail) {
  //         setQuantity(obj.quantity);
  //         setRateL(obj.price);
  //         let productCode = "";
  //         if (obj.orderType === "Fitting") {
  //           if (obj.orderDetail.fitting) {
  //             setFitting(obj.orderDetail.fitting);
  //             let fitting = _.find(fittingMasters, {
  //               fittingType: obj.orderDetail.fitting,
  //             });
  //             setFittingAmount(fitting.amount);
  //           }
  //           setRateL(obj.orderDetail.lRate);
  //           productCode =
  //             obj.orderDetail.lSph +
  //             "/" +
  //             obj.orderDetail.lCyl +
  //             "/" +
  //             obj.orderDetail.lAxis +
  //             "/" +
  //             obj.orderDetail.lAddition;
  //           setNameL(obj.orderDetail.productName + "-" + productCode);
  //         } else {
  //           setRateL(obj.rate);
  //           productCode =
  //             obj.orderDetail.lSph +
  //             "/" +
  //             obj.orderDetail.lCyl +
  //             "/" +
  //             obj.orderDetail.lAxis +
  //             "/" +
  //             obj.orderDetail.lAddition;
  //           if (obj.orderDetail.product) {
  //             setNameL(
  //               obj.orderDetail.product.productName + "-" + productCode
  //             );
  //           }
  //         }
  //         setOrderRef(obj.code);
  //         setLProductCode(productCode);
  //       }
  //     }
  //   }
  // }

  const afterSelectL = useCallback((codeL) => {
    console.log("after select L>> >> ", codeL, readyMasters);
    let obj;

    // First check if it's an order code
    if (orders && orders.length > 0) {
      obj = orders.find((o) => o.code === codeL);
    }

    // If not found in orders, check readyMasters
    if (!obj && readyMasters && readyMasters.length > 0) {
      obj = _.find(readyMasters, { productCode: codeL });
    }

    // If still not found, try to get from cache using the code prefix
    if (!obj && codeL && codeL.length >= 5) {
      // Try to find in cache by checking prefixes
      for (let i = codeL.length; i >= 5; i--) {
        const prefix = codeL.substring(0, i);
        const cachedData = getCachedCodes(userInfo.entity, prefix, "L");
        if (cachedData && cachedData.length > 0) {
          obj = cachedData.find((item) => item.productCode === codeL);
          if (obj) {
            // Update readyMasters with cached data so it's available for future use
            setReadyMasters(cachedData);
            break;
          }
        }
      }
    }

    if (obj) {
      console.log(obj, "this my product");

      // Check if it's an order (has orderDetail)
      if (obj.orderDetail) {
        console.log(obj, "594");
        setQuantity(obj.quantity);
        let productCode = "";
        if (obj.orderType === "Fitting") {
          if (obj.orderDetail.fitting) {
            setFitting(obj.orderDetail.fitting);
            let fitting = _.find(fittingMasters, {
              fittingType: obj.orderDetail.fitting,
            });
            setFittingAmount(fitting.amount);
          }
          setRateL(obj.orderDetail.lRate);
          productCode =
            obj.orderDetail.lSph +
            "/" +
            obj.orderDetail.lCyl +
            "/" +
            obj.orderDetail.lAxis +
            "/" +
            obj.orderDetail.lAddition;
          console.log("864orderDetailcomp");
          setNameL(obj.orderDetail.productName + "-" + productCode);
        } else {
          setRateL(obj.rate);
          productCode =
            obj.orderDetail.lSph +
            "/" +
            obj.orderDetail.lCyl +
            "/" +
            obj.orderDetail.lAxis +
            "/" +
            obj.orderDetail.lAddition;
          if (obj.orderDetail.product) {
            console.log("396comp");
            setNameL(obj.orderDetail.product.productName + "-" + productCode);
          }
        }
        setOrderRef(obj.code);
        setLProductCode(productCode);
        setDiscountPercent(0);
      } else if (obj.productName || obj.productCode) {
        // It's a readyMaster with productName or at least productCode
        console.log("hiiii", obj);
        // Handle null/undefined index and productName gracefully
        const indexPart = obj.index ? `${obj.index}-` : '';
        const productName = obj.productName || obj.productCode || '';
        setNameL(indexPart + productName);
        console.log(obj.productName, "byeee");
        console.log("814setnamecomplete", party);
        setRateL(obj?.rate);
        setBrandL(obj.brand);
        setLProductCode(obj?.productCode);
        setHsnCode(obj?.hsnCode);
        setTaxPercent(obj?.taxPercent);
        setLsph(obj?.sph);
        setLcyl(obj?.cyl);
        setLaxis(obj?.axis);
        setLadd(obj?.addition);
        // Discount logic — aligned with afterSelectR
        // Priority: 1) Range (productName + productCode) 2) Color
        const discounts = (party?.discounts || []).slice().reverse();
        const inputName = (obj.productName || "").trim().toLowerCase();
        const inputCode = (obj.productCode || "").trim();
        const inputColor = (obj.color || "").trim().toLowerCase();

        let appliedDiscount = discounts.find((rule) => {
          if (rule.type !== "Range") return false;
          if (!rule.product) return false;

          const ruleName = (rule.product.productName || "").trim().toLowerCase();
          const nameMatch = ruleName === inputName;
          const codeMatch =
            rule.product.codeRanges?.some(
              (rangeCode) => String(rangeCode).trim() === inputCode
            ) ?? false;

          return nameMatch && codeMatch;
        });

        if (!appliedDiscount) {
          appliedDiscount = discounts.find((rule) => {
            const isColorRule = !rule.type || rule.type === "Color";
            if (!isColorRule) return false;
            if (!rule.product?.color || !inputColor) return false;

            return (
              String(rule.product.color).trim().toLowerCase() === inputColor
            );
          });
        }

        if (appliedDiscount) {
          // if (appliedDiscount.product?.productName) {
          //   setNameL(appliedDiscount.product.productName);
          // }
          setBrandL(obj.brand);
          setDiscountPercent(appliedDiscount.discountPercent || 0);
        } else {
          setDiscountPercent(0);
        }
      }
    }
  }, [readyMasters, party, fittingMasters, orders, getCachedCodes, userInfo.entity]);

  const debouncedEffect = useMemo(
    () => {
      const debounced = _.debounce((codeR) => {
        console.log("useeffect debounced code R running2", codeR);
        let obj;
        let codes = [...orderCodes];
        let codesR = [...orderCodes];
        if (codeR) {
          obj = orders.find((o) => o.code === codeR);
          if (!obj) {
            if (codeR?.length < 5) {
              return;
            }

            // Check cache first
            const cachedData = getCachedCodes(userInfo.entity, codeR, "R");
            if (cachedData) {
              setReadyMasters(cachedData);
              const readyMasterCodes = cachedData.map((i) => i.productCode);
              const readyMasterCodesR = cachedData
                .filter((i) => i.side === "B" || i.side === "R")
                .map((i) => i.productCode);

              codes = [...orderCodes, ...readyMasterCodes];
              codesR = [...orderCodes, ...readyMasterCodesR];

              // Sort codesR array - move codes starting with 'o' to the end, then sort each group alphabetically
              codesR.sort((a, b) => {
                const aStartsWithO = a.toLowerCase().startsWith("o");
                const bStartsWithO = b.toLowerCase().startsWith("o");

                if (aStartsWithO && !bStartsWithO) {
                  return 1;
                } else if (!aStartsWithO && bStartsWithO) {
                  return -1;
                }
                return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
              });

              // Also sort the main codes array
              codes.sort((a, b) => {
                const aStartsWithO = a.toLowerCase().startsWith("o");
                const bStartsWithO = b.toLowerCase().startsWith("o");

                if (aStartsWithO && !bStartsWithO) {
                  return 1;
                } else if (!aStartsWithO && bStartsWithO) {
                  return -1;
                }
                return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
              });

              setCodesR(codesR);
              setCodes(codes);
              return;
            }

            // Cancel previous request
            if (codesRAbortControllerRef.current) {
              codesRAbortControllerRef.current.abort();
            }
            codesRAbortControllerRef.current = new AbortController();

            setLoadingCodesR(true);
            axios
              .get(GetAllReadyMastersCodesAPI(userInfo.entity, codeR, "R"), {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                signal: codesRAbortControllerRef.current.signal,
              })
              .then((res) => {
                const readyMastersData = res.data.readyMasters || [];
                // Limit results to 200 on frontend as well
                const limitedReadyMasters = readyMastersData.slice(0, 200);

                // Cache the results
                setCachedCodes(userInfo.entity, codeR, "R", limitedReadyMasters);

                setReadyMasters(limitedReadyMasters);
                const readyMasterCodes = limitedReadyMasters.map((i) => i.productCode);
                const readyMasterCodesR = limitedReadyMasters
                  .filter((i) => i.side === "B" || i.side === "R")
                  .map((i) => i.productCode);

                codes = [...orderCodes, ...readyMasterCodes];
                codesR = [...orderCodes, ...readyMasterCodesR];

                // Sort codesR array - move codes starting with 'o' to the end, then sort each group alphabetically
                codesR.sort((a, b) => {
                  const aStartsWithO = a.toLowerCase().startsWith("o");
                  const bStartsWithO = b.toLowerCase().startsWith("o");

                  // First, separate codes starting with 'o' from others
                  if (aStartsWithO && !bStartsWithO) {
                    return 1;
                  } else if (!aStartsWithO && bStartsWithO) {
                    return -1;
                  }
                  // Within the same group, sort alphabetically/numerically
                  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });
                setCodesR(codesR);

                // Also sort the main codes array
                codes.sort((a, b) => {
                  const aStartsWithO = a.toLowerCase().startsWith("o");
                  const bStartsWithO = b.toLowerCase().startsWith("o");

                  if (aStartsWithO && !bStartsWithO) {
                    return 1;
                  } else if (!aStartsWithO && bStartsWithO) {
                    return -1;
                  }
                  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });
                setCodes(codes);
              })
              .catch((e) => {
                if (e.name !== 'AbortError' && e.code !== 'ECONNABORTED') {
                  //console.log(e, "<<err");
                }
              })
              .finally(() => {
                setLoadingCodesR(false);
              });
          }
          // Sort codes before setting (when code length < 5, codes = orderCodes)
          codes.sort((a, b) => {
            const aStartsWithO = a.toLowerCase().startsWith("o");
            const bStartsWithO = b.toLowerCase().startsWith("o");

            if (aStartsWithO && !bStartsWithO) {
              return 1;
            } else if (!aStartsWithO && bStartsWithO) {
              return -1;
            }
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
          });
          setCodes(codes);
          if (obj) {
            if (obj.productName) {
              console.log("571comp", obj);
              setNameR(obj.productName);
              //console.log("sethere1");
              setRateR(obj.rate);
              setRProductCode(obj.productCode);
            } else {
              if (obj.orderDetail) {
                setQuantity(obj.quantity);
                setRateR(obj.price);
                let productCode = "";
                if (obj.orderType === "Fitting") {
                  if (obj.orderDetail.fitting) {
                    setFitting(obj.orderDetail.fitting);
                    let fitting = _.find(fittingMasters, {
                      fittingType: obj.orderDetail.fitting,
                    });
                    setFittingAmount(fitting.amount);
                  }
                  setRateR(obj.orderDetail.rRate);
                  productCode =
                    obj.orderDetail.rSph +
                    "/" +
                    obj.orderDetail.rCyl +
                    "/" +
                    obj.orderDetail.rAxis +
                    "/" +
                    obj.orderDetail.rAddition;
                  console.log(
                    "600comp",
                    obj,
                    obj.orderDetail.product.index,
                    obj.orderDetail.fitter,
                    "-",
                    obj.orderDetail.productName,
                    obj.orderDetail.productNameR,
                    "-",
                    obj.orderDetail.product.coating,
                    obj.orderDetail.fitting,
                    "-",
                    productCode
                  );
                  // setNameR(
                  //   obj.orderDetail.product.index || obj.orderDetail.fitter +
                  //     "-" +
                  //     obj.orderDetail.productName || obj.orderDetail.productNameR  +
                  //     "-" +
                  //     obj.orderDetail.product.coating || obj.orderDetail.fitting +
                  //     "-" +
                  //     productCode
                  // );
                  setNameR(
                    [
                      obj.orderDetail.product.index ?? obj.orderDetail.fitter,
                      obj.orderDetail.productName ?? obj.orderDetail.productNameR,
                      obj.orderDetail.product.coating ?? obj.orderDetail.fitting,
                      productCode,
                    ]
                      .filter(Boolean) // Removes undefined, null, or empty values
                      .join("-") // Joins the valid values with "-"
                  );
                } else {
                  setRateR(obj.rate);
                  productCode =
                    obj.orderDetail.rSph +
                    "/" +
                    obj.orderDetail.rCyl +
                    "/" +
                    obj.orderDetail.rAxis +
                    "/" +
                    obj.orderDetail.rAddition;
                  if (obj.orderDetail.product) {
                    console.log("769comp", obj);
                    setNameR(
                      obj.orderDetail.product.index +
                      "-" +
                      obj.orderDetail.productName +
                      "-" +
                      obj.orderDetail.product.coating +
                      "-" +
                      productCode
                    );
                    setRateR(obj?.orderDetail?.product?.price);
                    setHsnCode(obj?.orderDetail?.product?.hsnCode);
                    //console.log("sethere3");
                  }
                }
                setOrderRef(obj.code);
                setRProductCode(productCode);
              }
            }
          }
        }
        if (!codeR) {
          if (!codeL) {
            setQuantity("");
            setFittingAmount("");
            setFitting("");
            setOrderRef("");
            setRate("");
            setDiscountPercent("");
            setHsnCode("");
            setTaxPercent("");
          }
          setNameR("");
          setRateR("");
          setRProductCode("");
        }
        //console.log("hojaye shuru");
      }, 500);
      debouncedEffectRef.current = debounced;
      return debounced;
    },
    [orders, orderCodes, fittingMasters, userInfo.entity, authToken, getCachedCodes, setCachedCodes]
  );

  // useEffect(() => {
  //   //console.log("useeffect code R running2")
  //   debouncedEffect(codeR);
  // }, [codeR]);

  useEffect(() => {
    if (rateR) {
      setRate(rateR.toString());
    }

    if (rateL) {
      setRate(rateL.toString());
    }

    if (rateR && rateL) {
      //console.log("dono");
      let rate = (Number(rateR) + Number(rateL)) / 2;
      setRate(rate.toString());
    }
  }, [rateR, rateL]);

  useEffect(() => {
    let amount = 0;
    if (rate && quantity) {
      amount = Number(rate) * Number(quantity);
    }
    if (discountAmount) {
      // Discount Amount is treated as PER-UNIT discount, so multiply by quantity
      const qty = Number(quantity) || 0;
      const disPerUnit = Number(discountAmount) || 0;
      amount = amount - disPerUnit * qty;
    }
    // NOTE: discountPercent is NOT applied here because rate is already the discounted price
    // discountPercent is stored only for display/reference purposes
    if (discountPercent) {
      amount = amount - (amount * Number(discountPercent)) / 100;
    }
    if (fittingAmount) {
      amount += Number(fittingAmount) * Number(quantity);
    }
    if (tint && quantity) {
      amount += Number(quantity) * Number(tint);
    }
    setAmount(amount.toFixed(2));
  }, [rate, fittingAmount, discountAmount, discountPercent, tint, quantity]);

  useEffect(() => {
    let obj = _.find(fittingMasters, { fittingType: fitting });
    if (obj) {
      setFittingAmount(obj.amount);
    }
  }, [fitting]);

  async function _getUsers() {
    try {
      let res = await axios.get(GetAllAccountsWithLightweightAPI(userInfo.entity, 'sale'), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      let accounts = (res.data.accounts || []).filter(account => account.partyType === 'sale');
      console.log('Loaded sale parties for challan:', accounts.length);
      setUsers(accounts);
    } catch (e) {
      console.error('Error loading parties:', e);
      toast.error('Failed to load parties. Please refresh.', {
        position: "top-center",
        autoClose: 2000,
      });
      setUsers([]);
    }
  }

  async function _getFittingMasters() {
    // Check cache first
    try {
      const cached = localStorage.getItem(fittingMastersCacheKey);
      if (cached) {
        const cachedData = JSON.parse(cached);
        const cacheAge = Date.now() - cachedData.timestamp;
        // Cache valid for 1 hour
        if (cacheAge < 3600000) {
          setFittingMasters(cachedData.fittingMasters);
          setFittingMastersCodes(cachedData.fittingMastersCodes);
          return;
        }
      }
    } catch (e) {
      // Cache read failed, continue to fetch
    }

    // Cancel previous request if exists
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();

    setLoadingFittingMasters(true);
    try {
      let res = await axios.get(GetAllFittingMastersAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        signal: abortControllerRef.current.signal,
      });

      const fittingMastersCodes = res.data.fittingMasters.map((i) => i.fittingType);

      setFittingMasters(res.data.fittingMasters);
      setFittingMastersCodes(fittingMastersCodes);

      // Cache the result
      try {
        localStorage.setItem(fittingMastersCacheKey, JSON.stringify({
          fittingMasters: res.data.fittingMasters,
          fittingMastersCodes: fittingMastersCodes,
          timestamp: Date.now(),
        }));
      } catch (e) {
        // Cache write failed, continue
      }
    } catch (err) {
      if (err.name === 'AbortError' || err.code === 'ECONNABORTED') {
        // Request was cancelled, ignore error
        return;
      }
      // //// //console.log(err);
      // toast.error(('Cannot fetch data'), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    } finally {
      setLoadingFittingMasters(false);
    }
  }

  async function _getOrders() {
    try {
      if (party) {
        // Check cache first
        const cacheKey = `orders_${party._id}`;
        // const cached = ordersCacheRef.current.get(cacheKey);
        // if (cached) {
        //   setOrders(cached);
        //   return;
        // }

        // Cancel previous request if exists
        if (ordersAbortControllerRef.current) {
          ordersAbortControllerRef.current.abort();
        }
        ordersAbortControllerRef.current = new AbortController();

        setLoadingOrders(true);
        let res = await axios.get(
          GetAllOrdersAPI(userInfo.entity) +
          `&userId=${party._id}&isChallanCreated=false&orderAdminStatus=Confirmed&orderStatus=Completed&pagination=false`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
            signal: ordersAbortControllerRef.current.signal,
          }
        );
        console.log(res.data, "these are my orders");
        // Sort orders as latest first (assuming createdAt or updatedAt field exists)
        let sortedOrders = (res.data.orders || []).slice().sort((a, b) => {
          // Use createdAt or updatedAt, fallback to _id if not present
          const dateA = new Date(a.updatedAt || a.createdAt || a._id);
          const dateB = new Date(b.updatedAt || b.createdAt || b._id);
          return dateB - dateA;
        });
        setOrders(sortedOrders);

        // Cache the result
        ordersCacheRef.current.set(cacheKey, sortedOrders);
      } else {
        setOrders([]);
      }
    } catch (err) {
      if (err.name === 'AbortError' || err.code === 'ECONNABORTED') {
        // Request was cancelled, ignore error
        return;
      }
      // //// //console.log("error:", err);
      // toast.error(('Cannot fetch data'), {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    } finally {
      setLoadingOrders(false);
    }
  }

  async function _onSave(print) {
    if (isSavingChallan) return;
    try {
      // Check the pathname to determine which API to use
      let apiUrl;
      if (location.pathname.includes("creditNote")) {
        apiUrl = CreateCreditNoteAPI();
      } else if (location.pathname.includes("debitNote")) {
        apiUrl = CreateDebitNoteAPI();
      } else {
        apiUrl = CreateChallanAPI();
      }
      if (items?.length === 0) {
        if (location.pathname.includes("creditNote")) {
          toast.error("Please add a Credit Note", {
            position: "top-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else if (location.pathname.includes("debitNote")) {
          toast.error("Please add a Debit Note", {
            position: "top-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else {
          toast.error("Please add a Challan", {
            position: "top-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        return;
      }
      let totalAmount = 0;
      _.map(items, async (i) => {
        totalAmount =
          Number(totalAmount) + Number(i?.amount);
      });
      totalAmount = Number(totalAmount) + Number(packagingCost);
      console.log("amtFinale>>>>", totalAmount);
      // return

      // Balance Lock check (admin-defined)
      const lock = Number(party?.balanceLock || 0);
      if (lock > 0) {
        const current = Number(party?.runningChallanBalance || 0);
        console.log("current>>>>", party?.runningChallanBalance);
        const projected = current + Number(totalAmount || 0);
        if (projected > lock) {
          toast.error(
            `Balance locked for ${party?.name || "this account"}. Limit: ${lock}, Projected: ${Math.round(projected)}`,
            { position: "top-center", autoClose: 3000, theme: "light" }
          );
          return;
        }
      }

      setIsSavingChallan(true);
      let res = await axios.post(
        apiUrl,
        {
          items: (items || []).map((it) => ({
            ...it,
            taxPercent: 5,
            packagingTaxPercent: 5,
          })),
          amount: totalAmount,
          entity: userInfo.entity,
          packagingCost: packagingCost,
          packagingTaxPercent: 5,
          challanDate:
            challanDate == null
              ? moment().toISOString()
              : moment(challanDate).toISOString(),
          createdAt:
            challanDate == null
              ? moment().toISOString()
              : moment(challanDate).toISOString(),
          party: {
            accountCode: party.accountCode,
            accountId: party._id,
            accountName: party.name,
            whatsappNumber: party?.whatsappNumber,
            accountAddress: party.address,
            accountGst: party.gst,
            runningChallanBalance: party.runningChallanBalance + totalAmount,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log("resp>>>>", res);

      toast.success("Successfully Added!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      if (print) {
        showPrintModal(res.data);
        close();
      } else {
        close();
      }
    } catch (e) {
      if (e.response && e.response.status === 404) {
        console.log("Resource not found", e);
        // Customize your toast message for 404 error
        toast.error(`${e.response.data}`, {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        console.log("saverr", e.response ? e.response.data : e.message);
        toast.error("Something went wrong, Please Contact Admin", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
      close();
    } finally {
      setIsSavingChallan(false);
    }
  }

  function _onAddRecord() {
    const normalizedCodeR = (codeR ?? "").toString().trim();
    const normalizedCodeL = (codeL ?? "").toString().trim();
    const hasPrescriptionData =
      String(nameR || "").trim() ||
      String(nameL || "").trim() ||
      String(rSph || "").trim() ||
      String(rCyl || "").trim() ||
      String(rAxis || "").trim() ||
      String(rAdd || "").trim() ||
      String(lSph || "").trim() ||
      String(lCyl || "").trim() ||
      String(lAxis || "").trim() ||
      String(lAdd || "").trim();
    if (
      party === null ||
      (!isPrescriptionOrderMode && !normalizedCodeR && !normalizedCodeL) ||
      (isPrescriptionOrderMode && !hasPrescriptionData) ||
      quantity === ""
    ) {
      toast.error("Please fill all the Fields", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    // Reject quantity like .5 (must be 0.5 or similar)
    const qtyStr = String(quantity).trim();
    if (qtyStr.startsWith(".")) {
      toast.error("Quantity must not start with a decimal point (use 0.5 instead of .5)");
      return;
    }
    const qtyNum = Number(quantity);
    if (!Number.isFinite(qtyNum) || qtyNum < 0) {
      toast.error("Please enter a valid quantity (e.g. 0.5 or 1)");
      return;
    }

    // Apply reverse entry logic to quantity and amount
    let finalQuantity = quantity;
    let finalAmount = amount;
    if (reverseEntry) {
      finalQuantity = -Math.abs(Number(quantity));
      finalAmount = -Math.abs(Number(amount));
    }

    let data = {
      codeR: normalizedCodeR || null,
      codeL: normalizedCodeL || null,
      isPrescriptionOrder: Boolean(isPrescriptionOrderMode),
      nameR,
      brandR,
      brandL,
      nameL,
      quantity: finalQuantity,
      rateR,
      rSph,
      lSph,
      rCyl,
      lCyl,
      rAxis,
      lAxis,
      rAdd,
      lAdd,
      rateL,
      rate,
      discountAmount,
      discountPercent,
      fitting,
      fittingAmount,
      tint,
      amount: finalAmount,
      packagingCost,
      orderRef,
      lProductCode,
      rProductCode,
      hsnCode,
      taxPercent: 5,
      packagingTaxPercent: 5,
      coating,
      // orderRef
    };
    //// //console.log(data, "this is my data");
    let copy = _.clone(items);
    copy.push(data);
    setItems(copy);
    setCodeR(null);
    setCodeL(null);
    setNameR("");
    setNameL("");
    setQuantity("");
    setRateL("");
    setRateR("");
    setRate("");
    setDiscountAmount("");
    setDiscountPercent("");
    setFittingAmount("");
    setFitting("");
    setTint("");
    setAmount("");
    setOrderRef("");
    setSelectR({});
    setSelectL({});
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>
                  {location.pathname.includes("creditNote")
                    ? "Credit Note Add"
                    : location.pathname.includes("debitNote")
                      ? "Debit Note Add"
                      : "Challan Add"}
                </h4>
                <Box display={"flex"} alignItems={"center"}>
                  {orders?.length > 0 && (
                    <Button
                      style={{ color: "white" }}
                      onClick={() => setOpenOrdersDialog(true)}
                    >
                      View Orders
                    </Button>
                  )}
                  {/* <Box>
                    <CustomInput
                      labelText="Packaging Cost"
                      id="packag"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: nameR,
                        disabled: true,
                      }}
                    />
                  </Box> */}

                  <Button
                    style={{ color: "white" }}
                    onClick={() => setOpenColorsDialog(true)}
                  >
                    GET CODES
                  </Button>
                  <Button
                    style={{ color: "white" }}
                    onClick={() => {
                      const next = !isPrescriptionOrderMode;
                      setIsPrescriptionOrderMode(next);

                      // Switching modes should not keep stale selections/derived values.
                      setSelectR({});
                      setSelectL({});
                      setCodeR(null);
                      setCodeL(null);
                      cleanupCodeR();
                      cleanupCodeL();
                    }}
                  >
                    {isPrescriptionOrderMode ? "READY MASTER MODE" : "ADD PRESCRIPTION ORDER"}
                  </Button>
                  <Button style={{ color: "white" }} onClick={close}>
                    Close
                  </Button>
                  <Button
                    style={{ color: "white" }}
                    onClick={() => _onSave(false)}
                    disabled={isSavingChallan}
                  >
                    {isSavingChallan ? "Saving…" : "Save"}
                  </Button>
                  <Button
                    style={{ color: "white" }}
                    onClick={() => _onSave(true)}
                    disabled={isSavingChallan}
                  >
                    {isSavingChallan ? "Saving…" : "Save & Print"}
                  </Button>
                </Box>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={3} sm={3} md={2} style={{ marginTop: 25 }}>
                  <MuiPickersUtilsProvider utils={DateUtils}>
                    <DatePicker
                      label="Challan Date"
                      fullWidth
                      format="DD/MM/YYYY"
                      value={challanDate}
                      // defaultValue={moment.utc().format("DD/MM/YYYY")}
                      onChange={(date) => {
                        setChallanDate(date);
                      }}
                      animateYearScrolling
                    />
                  </MuiPickersUtilsProvider>
                </GridItem>

                <GridItem xs={3} sm={3} md={2}>
                  <Autocomplete
                    className={classes.formControl}
                    options={users}
                    fullWidth
                    filterOptions={filterOptions}
                    value={party}
                    onChange={(event, value) => setParty(value)}
                    getOptionLabel={(option) => option.name}
                    id="party"
                    style={{ marginTop: 26 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Party" />
                    )}
                  />
                </GridItem>
                {!isPrescriptionOrderMode && (
                  <GridItem xs={2} sm={2} md={2}>
                    {codeR && Object.keys(selectR)?.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        padding: "8px 0",
                      }}
                    >
                      {/* Column for displaying the selected code */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginRight: 10,
                        }}
                      >
                        <CustomInput
                          labelText="Order Code R"
                          id="ordercodeR"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: codeR,
                            disabled: true,
                          }}
                        />
                      </div>

                      {/* Button for deselecting */}
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => {
                          setCodeR(null); // Reset codeR to null or an empty value
                          setSelectR({}); // Optionally clear selectR or trigger other effects
                          cleanupCodeR(); // Undo all operations that happened when codeR was selected
                        }}
                        style={{
                          marginLeft: 10, // Add space between the button and the input
                          marginTop: 30, // Add space between the button and the input
                          height: 36,
                          // Match the height with the CustomInput field
                        }}
                      >
                        X
                      </Button>
                    </div>
                    ) : (
                    <Autocomplete
                      loading={loadingCodesR}
                      className={classes.formControl}
                      options={codesR.slice(0, 200)}
                      fullWidth
                      filterOptions={filterOptions}
                      value={codeR}
                      onChange={(event, value) => {
                        setCodeR(value);
                        if (value) {
                          afterSelectR(value);
                        } else {
                          // If value is cleared (null), cleanup
                          setSelectR({});
                          cleanupCodeR();
                        }
                      }}
                      onInputChange={(event, value) => {
                        debouncedEffect(value);
                      }}
                      getOptionLabel={(option) => option}
                      style={{ marginTop: 26 }}
                      id="codeR"
                      disabled={Object.keys(selectR)?.length > 0}
                      renderInput={(params) => (
                        <TextField {...params} label="Code R" />
                      )}
                    />
                    )}
                  </GridItem>
                )}

                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Name R"
                    id="nameR"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled={!isPrescriptionOrderMode}
                    inputProps={{
                      value: nameR,
                      ...(isPrescriptionOrderMode
                        ? { onChange: (e) => setNameR(e.target.value) }
                        : { readOnly: true }),
                    }}
                  />
                </GridItem>
                {!isPrescriptionOrderMode && (
                  <GridItem xs={2} sm={2} md={2}>
                    {codeL && Object.keys(selectL)?.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        padding: "8px 0",
                      }}
                    >
                      {/* Column for displaying the selected code */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginRight: 10,
                        }}
                      >
                        <CustomInput
                          labelText="Order Code L"
                          id="ordercodeL"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: codeL,
                            disabled: true,
                          }}
                        />
                      </div>

                      {/* Button for deselecting */}
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => {
                          setCodeL(null); // Reset codeL to null or an empty value
                          setSelectL({}); // Optionally clear selectL or trigger other effects
                          cleanupCodeL(); // Undo all operations that happened when codeL was selected
                        }}
                        style={{
                          marginLeft: 10, // Add space between the button and the input
                          marginTop: 30, // Add space between the button and the input
                          height: 36,
                          // Match the height with the CustomInput field
                        }}
                      >
                        X
                      </Button>
                    </div>
                    ) : (
                    <Autocomplete
                      loading={loadingCodesL}
                      className={classes.formControl}
                      options={codesL.slice(0, 200)}
                      fullWidth
                      filterOptions={filterOptions}
                      value={codeL}
                      onChange={(event, value) => {
                        setCodeL(value);
                        if (value) {
                          afterSelectL(value);
                        } else {
                          // If value is cleared (null), cleanup
                          setSelectL({});
                          cleanupCodeL();
                        }
                      }}
                      onInputChange={(event, value) => {
                        //console.log("val", value)
                        // setCodeL(value)
                        debouncedEffectL(value);
                      }}
                      getOptionLabel={(option) => option}
                      style={{ marginTop: 26 }}
                      id="codeL"
                      renderInput={(params) => (
                        <TextField {...params} label="Code L" />
                      )}
                    />
                    )}
                  </GridItem>
                )}
                <GridItem xs={3} sm={3} md={3}>
                  <CustomInput
                    labelText="Name L"
                    id="nameL"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled={!isPrescriptionOrderMode}
                    inputProps={{
                      value: nameL,
                      ...(isPrescriptionOrderMode
                        ? { onChange: (e) => setNameL(e.target.value) }
                        : { readOnly: true }),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Quantity"
                    id="quantity"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: quantity,
                      onChange: (e) => {
                        const val = e.target.value;
                        const trimmed = String(val).trim();
                        // Disallow .5 or any value starting with decimal point; allow 0.5
                        if (trimmed !== "" && trimmed.startsWith(".")) {
                          toast.error("Quantity must not start with a decimal point (use 0.5 instead of .5)");
                          return;
                        }
                        setQuantity(val);
                      },
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Rate R"
                    id="rateR"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rateR,
                      onChange: (e) => setRateR(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Rate L"
                    id="rateL"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: rateL,
                      onChange: (e) => setRateL(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Rate"
                    id="rate"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled
                    inputProps={{
                      value: rate,
                      disabled: true,
                      onChange: (e) => setRate(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Dis %"
                    id="discountPercent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: discountPercent,
                      onChange: (e) => setDiscountPercent(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Dis Amt/Qty"
                    id="discountAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      value: discountAmount,
                      onChange: (e) => setDiscountAmount(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <Autocomplete
                    loading={loadingFittingMasters}
                    className={classes.formControl}
                    options={fittingMastersCodes}
                    fullWidth
                    value={fitting}
                    onChange={(event, value) => setFitting(value)}
                    getOptionLabel={(option) => option}
                    style={{ marginTop: 26 }}
                    id="fitting"
                    renderInput={(params) => (
                      <TextField {...params} label="Fitting" />
                    )}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Fit Amt"
                    id="fittingAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "number",
                      value: fittingAmount,
                      onChange: (e) => setFittingAmount(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Hsn Code"
                    id="hsnCode"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: hsnCode,
                      disabled: true,
                      onChange: (e) => setHsnCode(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Tax Percent"
                    id="taxPercent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: taxPercent,
                      onChange: (e) => setTaxPercent(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Tint"
                    id="tint"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tint,
                      onChange: (e) => setTint(e.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Amount"
                    id="amount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: amount,
                      onChange: (e) => setAmount(e.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Order Ref"
                    id="orderRef"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: orderRef,
                      onChange: (e) => setOrderRef(e.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <Fab
                    color="primary"
                    aria-label="add"
                    className={classes.fab}
                    onClick={_onAddRecord}
                  >
                    <AddIcon />
                  </Fab>
                </GridItem>

                <GridItem xs={2} sm={2} md={2}>
                  <CustomInput
                    labelText="Pkg tax %"
                    id="packagingTaxPercent"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: packagingTaxPercent,
                      onChange: (e) => setPackagingTaxPercent(e.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Pkg Cost"
                    id="packagingCost"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: packagingCost,
                      onChange: (e) => setPackagingCost(e.target.value),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Total Qty"
                    id="totQuant"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled
                    // value={sumOfQuantities}
                    inputProps={{
                      value: sumOfQuantities,
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <CustomInput
                    labelText="Total Amt"
                    id="totQuant"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    disabled
                    // value={sumOfAmounts}
                    inputProps={{
                      value: Number(sumOfAmounts) + Number(packagingCost),
                    }}
                  />
                </GridItem>

                <GridItem xs={1} sm={1} md={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={reverseEntry}
                        onChange={(e) => setReverseEntry(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Reverse Entry"
                    style={{ marginTop: 26 }}
                  />
                </GridItem>

                {_.isEmpty(items) ? null : (
                  <GridItem xs={12}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={"center"}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {items.map((row, index) => {
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.code}
                            >
                              {columns.map((column) => {
                                const value = row[column.id];
                                if (column.id === "action") {
                                  return (
                                    <TableCell align={"center"}>
                                      <Box
                                        display={"flex"}
                                        justifyContent={"center"}
                                      >
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() => {
                                            let copy = _.clone(items);
                                            copy.splice(index, 1);
                                            setItems(copy);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </TableCell>
                                  );
                                }
                                return (
                                  <TableCell key={column.id} align={"center"}>
                                    {value}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </GridItem>
                )}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {openOrdersDialog && (
        <ChallanOrdersDialog
          open={openOrdersDialog}
          onClose={() => setOpenOrdersDialog(false)}
          data={orders}
          OnR={setR}
          OnL={setL}
        />
      )}

      {openColorsDialog && (
        <ColorsDialog
          open={openColorsDialog}
          onClose={() => setOpenColorsDialog(false)}
          data={readyMasterRange}
        />
      )}
    </Dialog>
  );
}
